
import { faChevronDown, faTimes } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'ButtonDropdown',

  props: {
    options: {
      type: Array,
      default: () => [
        {
          label: 'Option label',
          prefixIcon: faChevronDown,
          onClick: () => {}
        }
      ]
    },

    shouldShowCancel: {
      type: Boolean,
      default: false
    },

    dropdownSize: {
      type: String,
      default: 'md',
      validator: prop => ['sm', 'md', 'auto'].includes(prop)
    },

    boundaryElement: {
      type: HTMLElement,
      required: false,
      default: null
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    buttonLabel: {
      type: String,
      default: 'Label'
    },

    buttonSuffixIcon: {
      type: Object,
      default: () => faChevronDown
    },

    buttonPriority: {
      type: String,
      default: 'default'
    },

    dropdownPlacement: {
      type: String,
      default: 'bottom-end',
      validator: prop =>
        [
          'auto',
          'auto-start',
          'auto-end',
          'top',
          'top-start',
          'top-end',
          'bottom',
          'bottom-start',
          'bottom-end',
          'right',
          'right-start',
          'right-end',
          'left',
          'left-start',
          'left-end'
        ].includes(prop)
    },

    buttonSize: {
      type: String,
      default: 'xs'
    }
  },

  computed: {
    compOptions() {
      if (!this.shouldShowCancel) {
        return this.options
      }

      return [
        ...this.options,
        {
          label: this.$t('cancel'),
          prefixIcon: faTimes
        }
      ]
    },

    compPopperConfig() {
      const config = {
        placement: this.dropdownPlacement
      }

      if (this.boundaryElement) {
        config.modifiers = [
          {
            name: 'preventOverflow',
            options: {
              boundary: this.boundaryElement
            }
          }
        ]
      }

      return config
    }
  },

  methods: {
    // Mobile dropdowns moved into the app template in order to fix issues with positioning in scrollable modals
    setMobileDropdownOptions() {
      this.$store.commit('dropdownOverlay/setDropdownOptions', this.compOptions)
    }
  }
}
